import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { ErrorBoundary } from './app/ErrorBoundary';
import { installDomMutationGuard } from './app/domMutationGuard';
import { initSentry } from './app/sentry';
import './i18n';
import './styles.css';

// Before React mounts: page translators rewrite text nodes behind React's back.
installDomMutationGuard();
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode><ErrorBoundary><App /></ErrorBoundary></StrictMode>,
);
